import { observer } from "mobx-react-lite"
import { Outlet } from "react-router-dom"
import usersStore from "features/users/store/users-store"
import customerStore from "features/organizations/customers/store/customer-store"
import { useIntl } from "@metsooutotec/modes-react-components"
import { useEffect } from "react"
import LowSpinner from "components/common/low-spinner"

const UsersLoader = observer(() => {
    const { formatMessage } = useIntl()

    useEffect(() => {
        if (!customerStore.customers.length && !customerStore.customersLoading) {
            customerStore.loadAllCustomers()
        }

        if (!usersStore.users.length && !usersStore.usersLoading) {
            usersStore.loadAllUsersAsync()
        }
    }, [])

    const isUsersLoading = usersStore.usersLoading || !usersStore.users.length
    const isCustomersLoading = customerStore.customersLoading || !customerStore.customers.length

    if (isUsersLoading) {
        return <LowSpinner id={formatMessage("users.loading")} />
    }

    if (isCustomersLoading) {
        return <LowSpinner id={formatMessage("customer.loading")} />
    }

    return <Outlet />
})

export default UsersLoader
